import BigNumber from 'bignumber.js';

// 함수 정의: 소수점 0 절사
export const trimTrailingZeros = (value) => {
  return value.replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1');
};
export const NumWithComma = (aNum) => {
  const parts = aNum.split('.');
  // 정수 부분에만 천 단위 구분 기호(콤마) 적용
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 정수와 소수 부분을 다시 합침
  return parts.join('.');
};
export const fiexdDecimal = (aAmount, aFixed = 2) => {
  const re = isNaN(Number(aAmount)) ? '0' : BigNumber(aAmount).toFixed(aFixed);
  return re;
};

// 3개의 함수를 한 번에 설정 패키지
// 천단위 콤마, 소수점 자리 및 소수점 마지막 0이면 절사
export const packBigNumbers = (value, decimal = 2) => {
  return trimTrailingZeros(NumWithComma(fiexdDecimal(value, decimal)));
};

/**
 * 소수점 마지막에 0 제거
 * @param aValue 수량
 * @param digit (기본 2) 표시할 자릿수
 * @returns
 */
export const cutDecimalZero = (aValue, digit = 2) => {
  const re = BigNumber(cutCommas(aValue))
    .toFormat(digit, 1)
    .replace(/\.?0+$/, '');
  return re;
};

// 콤마 제거
export const cutCommas = (aValue) => {
  if (!aValue) return '0';
  return aValue.replace(/,/g, ''); // 모든 쉼표 제거
};

